import { Globe } from "lucide-react";
import { GlassCard } from "@/components/GlassCard";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useLanguage } from "@/i18n/LanguageContext";

export const LanguageCard = () => {
  const { t } = useLanguage();
  return (
    <GlassCard className="p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
            <Globe size={16} className="text-cyan-300/80" />
          </div>
          <p className="text-sm font-medium">{t("profile.language")}</p>
        </div>
        <LanguageToggle />
      </div>
    </GlassCard>
  );
};
